import React from 'react';
import { Route, Routes } from 'react-router-dom';
import EditType from './SupplierType/Edit';
import CreateBaseType from './BaseSupplierType/CreateBaseType';
import EditSupplier from './Supplier/Edit';
import SupplierList from './Supplier/SupplierList';
import SupplierTypeList from './SupplierType/SupplierTypeList';
import BaseSupplierTypeList from './BaseSupplierType/BaseSupplierTypeList';
// import EditBaseSupplierType from './BaseSupplierType/EditBaseSupplierType';
import './index.css';
import ErrorPage from '../Shared/ErrorPage';
import { ConstantActions } from '../../Services/_actions/constant.actions.js';
import { globalpermissions } from '../../Services/Permission.js';
import ProtectedRoute from '../Routes/ProtectedRoute.jsx';

const Supplier = () => {
  const actions = ConstantActions();

  return (
    <div className="supplier">
      <Routes>
        <Route path="*" element={<ErrorPage />} />
        {/* <Route exact path={`/create`} element={<EditSupplier />} />
        <Route exact path={`/list`} element={<SupplierList />} /> */}
        {/* <Route exact path={`/edit/:supplierId`} element={<EditSupplier />} /> */}
        {/* <Route exact path={`/type/create`} element={<EditType />} /> */}
        {/* <Route exact path={`/type/list`} element={<SupplierTypeList />} /> */}
        {/* <Route exact path={`/type/edit/:supplierTypeId`} element={<EditType />} /> */}
        {/* <Route exact path={`/base-type/create`} element={<CreateBaseType />} />
        <Route exact path={`/base-type/create/:baseSupplierTypeId`} element={<CreateBaseType />} /> */}
        {/* <Route exact path={`/base-type/list`} element={<BaseSupplierTypeList />} /> */}
        {/* <Route
          exact
          path={`/base-type/edit/:baseSupplierTypeId`}
          element={<EditBaseSupplierType />}
        /> */}
        <Route
          exact
          path={`/create`}
          element={
            <ProtectedRoute
              element={<EditSupplier />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicSupplierPageAccess,
              ])}
            />
          }
        />
        <Route
          exact
          path={`/list`}
          element={
            <ProtectedRoute
              element={<SupplierList />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicSupplierPageAccess,
              ])}
            />
          }
        />
        <Route
          exact
          path={`/edit/:supplierId`}
          element={
            <ProtectedRoute
              element={<EditSupplier />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicSupplierPageAccess,
              ])}
            />
          }
        />
        <Route
          exact
          path={`/type/create`}
          element={
            <ProtectedRoute
              element={<EditType />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicSupplierPageAccess,
              ])}
            />
          }
        />
        <Route
          exact
          path={`/type/list`}
          element={
            <ProtectedRoute
              element={<SupplierTypeList />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicSupplierPageAccess,
              ])}
            />
          }
        />
        <Route
          exact
          path={`/type/edit/:supplierTypeId`}
          element={
            <ProtectedRoute
              element={<EditType />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicSupplierPageAccess,
              ])}
            />
          }
        />
        <Route
          exact
          path={`/base-type/create`}
          element={
            <ProtectedRoute
              element={<CreateBaseType />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicSupplierPageAccess,
              ])}
            />
          }
        />
        <Route
          exact
          path={`/base-type/create/:baseSupplierTypeId`}
          element={
            <ProtectedRoute
              element={<CreateBaseType />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicSupplierPageAccess,
              ])}
            />
          }
        />
        <Route
          exact
          path={`/base-type/list`}
          element={
            <ProtectedRoute
              element={<BaseSupplierTypeList />}
              permissionGranted={actions.userHasPermission([
                globalpermissions?.pagePermissions?.dynamicSupplierPageAccess,
              ])}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default Supplier;
